import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import type RouterService from '@ember/routing/router-service';

class DataListRoute extends Route {
  @service declare betaToggle: BetaToggleService;
  @service declare router: RouterService;

  queryParams = {
    search: {
      refreshModel: false,
    },
  };

  beforeModel() {
    if (!this.betaToggle.showKnowledgeBaseFeatures)
      this.router.transitionTo('home');
  }

  model() {
    return {};
  }
}

export default instrumentRoutePerformance(DataListRoute);
